import React from "react";
import { SidebarContainer, Icon, MailIcon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SideBtnWrap, SidebarRoute } from "./sidebarelements";
import { useTranslation } from "react-i18next";

const Sidebar = ({ isOpen, toggle }) => {
  const { t } = useTranslation();
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink onClick={toggle} to="/">
          {t('navHome.txt')} 
          </SidebarLink>
          <SidebarLink onClick={toggle} to="/project">
          {t('navProject.txt')}
          </SidebarLink>
          <SidebarLink onClick={toggle} to="/team">
          {t('navTeam.txt')} 
          </SidebarLink>
          <SidebarLink onClick={toggle} to="/donators">
          {t('navDonators.txt')}
          </SidebarLink>
          <SidebarLink onClick={toggle} to="/join">
          {t('navJoin.txt')}
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to="/contact">
            <MailIcon />
            {t('navContact.txt')} 
          </SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
